import { Component} from '@angular/core';
import {NavController, NavParams, LoadingController, Loading, ModalController} from 'ionic-angular';

// Component Imports
import {CreateReportPage} from '../create-report/create-report.component';
import {ContinueReportPage} from '../continue-report/continue-report.component';
import {SettingsPage} from '../settings/settings.component';
import {MileagePage} from '../mileage/mileage.component';
import {LoginPage} from '../login/login.component';

// Provider Imports
import {rsProjectSvc} from '../../services/project.service';
import {rsEmployeeSvc} from '../../services/employee.service';
import {rsReportSvc} from '../../services/report.service';
import {rsSessionSvc} from '../../services/auth.service';

@Component({
  templateUrl: 'home.html',
  providers: [
    rsEmployeeSvc,
  ]
})
export class HomePage {
  constructor(
    private navCtrl : NavController,
    private navParams : NavParams,
    private loadingCtrl : LoadingController,
    private modalCtrl : ModalController,
    private projectSvc : rsProjectSvc,
    private employeeSvc : rsEmployeeSvc,
    private reportSvc : rsReportSvc,
    private authSvc : rsSessionSvc
  ) {
    // Constructor
  }

  onLogOutClick( event ) {
    let loader : Loading = this.loadingCtrl.create( {
        content: "Logging out...",
        dismissOnPageChange: true
    });   
    loader.present().then( () => {             
      this.authSvc.logout().subscribe( () => {
        // Successfully logged out, so now let's navigate back to logout page
        this.navCtrl.setRoot( LoginPage, {}, {
            animate: true,
            direction: "back"
        });
      });
    });
  }

  onCreateReportClick(event) {
      let loading = this.loadingCtrl.create({
          content : 'Loading...'
      });
      loading.present().then( () => {
        this.projectSvc.getProjects().subscribe( result => {
          this.navCtrl.push( CreateReportPage, {
            projectList: result
          },
          {
            animate: true,
            direction: "forward"
          }).then( () => {
            loading.dismiss();
          });
        });
      });
  }
  onContinueReportClick(event) {
    let loading = this.loadingCtrl.create({
        content : 'Loading...',
        dismissOnPageChange: true
    });
    loading.present().then( () => {
      this.reportSvc.getReports().subscribe( result => {
          this.navCtrl.push(ContinueReportPage, {
              reportList: result
          },
          {
              animate: true,
              direction: "forward"
          }).then( () => {
            loading.dismiss();
          });
      });
    });
  }
  onMileageReportClick(event) {
    let loading = this.loadingCtrl.create({
      content: 'Loading...',
      dismissOnPageChange: true
    });
    loading.present().then( () => {
      this.navCtrl.push(MileagePage, {

      },
      {
        animate: true,
        direction: "forward"
      }).then( () => {
        loading.dismiss();
      });
    });
  }
  onSettingsClick(event) {
    // Create our ModalInstance and configure for creating 
    this.modalCtrl.create( SettingsPage ).present(); 
  }
}




 // @ViewChild('artCanvas') myCanvas : ElementRef;
  // ionViewDidEnter() {

  //   console.log('view did enter');
  //   var mouse = {x: 0, y: 0};

  //   let canvas : HTMLCanvasElement = this.myCanvas.nativeElement;
  //   console.log('canvas: ', canvas );
  //   let ctx : CanvasRenderingContext2D = canvas.getContext("2d");
  //   console.log('context: ', ctx );
  //   ctx.lineWidth = 3;
  //   ctx.lineJoin = 'round';
  //   ctx.lineCap = 'round';
  //   ctx.strokeStyle = '#00CC99';

  //   canvas.addEventListener('mousemove', function(e : any) {
  //     var totalOffsetX = 0;
  //     var totalOffsetY = 0;


  //     var currentElement : any = canvas;

  //     do {
  //       totalOffsetX += currentElement.offsetLeft;
  //       totalOffsetY += currentElement.offsetTop;
  //     }
  //     while( currentElement = currentElement.offsetParent );

  //     mouse.x = e.pageX - totalOffsetX;
  //     mouse.y = e.pageY - totalOffsetY;
  //   });

  //   canvas.addEventListener('mousedown', function(e) {
  //     ctx.beginPath();
  //     ctx.moveTo( mouse.x, mouse.y );

  //     canvas.addEventListener('mousemove', onPaint, false );
  //   }, false );

  //   canvas.addEventListener('mouseup', function(e) {
  //     canvas.removeEventListener('mousemove', onPaint, false );
  //   }, false );

  //   var onPaint = function() {
  //     ctx.lineTo(mouse.x, mouse.y);
  //     ctx.stroke();
  //   };

  // }


// WEBPACK FOOTER //
// ./src/pages/home/home.component.ts